import { useLocalStorage } from '@vueuse/core'
import { LocalStorageKeys, LocalStorageKeyManager } from '~/store/LocalStorageKeyManager'
import type { Auth } from '~/http/auth/types'

export const useAuthenticationStore = useLocalStorage<Auth>(
  LocalStorageKeyManager.createStorageKey(LocalStorageKeys.AUTHORIZATION),
  {
    accessToken: '',
    refreshToken: '',
  },
)
